import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { KeyboardService } from 'src/app/shared/components/keyboard/keyboard.service';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { S3_URL_BASE } from 'src/environments/environment';
import {
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from './system-module-select-config';
import { SystemModuleService } from '../../../system-modules/crud-service';
import { take } from 'rxjs';
import { getSystemTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-type.enum';
import { FormBuilder, FormGroup } from '@angular/forms';

export interface PeriodicElement {
  isSelected: boolean;
  code: string;
  image: string;
  name: string;
  productCategory: string;
  productType: any;
  purchasePrice: number;
  salePrice1: number;
  stock: number;
  unitMeasure: string;
}

@Component({
  selector: 'app-system-module-select',
  templateUrl: './system-module-select.component.html',
  styleUrls: ['./system-module-select.component.sass'],
  providers: [SystemModuleService],
})
export class SystemModuleSelectComponent implements OnInit {
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  @Input('hidePagination') hidePagination: boolean;
  @Input() hasFilter: boolean = true;
  @Input('hideFilter') hideFilter: boolean;

  configColumns = TABLE_CONFIG_COLUMNS;
  displayedColumns: string[] = COLUMNS_TO_SHOW_WEB;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  params: any = {
    getRelation: 1,
    limit: 10,
    page: 0,
    filter: '',
    onlyActives: 0,
  };
  length: 0;
  indexSelect: number = -1;
  elementSelected: any;
  data = [];

  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  applied: boolean = false;

  keyboardChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public dialog: MatDialog,
    private service: SystemModuleService,
    public dialogRef: MatDialogRef<SystemModuleSelectComponent>,
    private toastService: ToastService,
    public keyboardService: KeyboardService,
    @Inject(MAT_DIALOG_DATA)
    public dataDialog: any,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.applyFilter(Object.assign({ target: { value: event } }));
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.params.filter = filterValue?.toUpperCase();
    this.loadList();
  }

  public pageEvent(event: PageEvent): PageEvent {
    this.params = { page: event.pageIndex, limit: event.pageSize };
    this.loadList();
    return event;
  }

  public setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput)
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
  }

  public loadList() {
    if (this.dataDialog.system) {
      let formGroupFilter = this.fb.group({
        system: [this.dataDialog.system],
        name: [''],
      });

      this.submitAdvancedFilter(formGroupFilter);
    } else {
      let params = this.params;

      this.service.listAll(params).subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            item['system'] = item.system?.name;

            this.dataDialog.modulesSelected?.forEach((element: any) => {
              if (element.id === item.id) {
                item.isSelected = true;
              }
            });

            return item;
          })
        );
      });
    }
  }

  public isAllSelected() {
    const numSelected = this.dataSource.data.filter(
      (item) => item.isSelected
    ).length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public toggleAllRows() {
    if (this.isAllSelected()) {
      this.dataSource.data.map((item: any) => (item.isSelected = false));
      return;
    }

    this.dataSource.data.map((item: any) => (item.isSelected = true));
  }

  public getFieldStyle(property: string, value: string): string {
    return '';
  }

  public checkboxLabel(row?: PeriodicElement): string {
    if (!row) return `${this.isAllSelected() ? 'deselect' : 'select'} all`;

    return `${row.isSelected ? 'deselect' : 'select'} row`;
  }

  public getValue(config: IColumnConfigTableResponsive, data: any) {
    return GlobalUtils.getValueByTypeColumnTableResponsive(config, data);
  }

  public selectItem(element: any, idx: number) {
    this.indexSelect = idx;
    this.elementSelected = element;
    this.toggle(element);
  }

  get fieldTypeEnum() {
    return FieldTypeEnum;
  }

  public getUrl(value: string) {
    return `${S3_URL_BASE}${value}`;
  }

  public confirm() {
    this.dialogRef.close({
      element: this.dataSource.data.filter((item: any) => item.isSelected),
    });
  }

  public hasValue() {
    return this.dataSource.data.filter((item) => item.isSelected).length > 0;
  }

  public toggle(row: PeriodicElement) {
    row.isSelected = !row.isSelected;
  }

  submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            item['system'] = item.system?.name;

            this.dataDialog.modulesSelected?.forEach((element: any) => {
              if (element.id === item.id) {
                item.isSelected = true;
              }
            });

            return item;
          })
        );
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.system) params.system = filter.system;

    if (filter.name) params.name = filter.name.toUpperCase();
    else delete params.name;

    return params;
  }
}
